(function(){"use strict";/* MTL 2026-10-18: locale-aware product path + strings from theme locales (#mtl-trust-i18n), English fallbacks unchanged. */if(!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(window.location.pathname))return;var mtlI18n={};try{var mtlI18nEl=document.getElementById("mtl-trust-i18n");mtlI18nEl&&(mtlI18n=JSON.parse(mtlI18nEl.textContent)||{})}catch(e){mtlI18n={}}function mtlT(k,d){return typeof mtlI18n[k]=="string"&&mtlI18n[k]?mtlI18n[k]:d}function injectCSS(){if(document.getElementById("mtl-pdp-sticky-eta-css"))return;const style=document.createElement("style");style.id="mtl-pdp-sticky-eta-css",style.textContent=`
      /* Sticky mobile ATC bar */
      .mtl-sticky-atc {
        position: fixed;
        left: 0; right: 0; bottom: -100px;
        background: #fff;
        border-top: 1px solid rgba(0,0,0,0.08);
        box-shadow: 0 -4px 16px rgba(0,0,0,0.08);
        padding: 10px 12px;
        display: none;
        align-items: center;
        gap: 10px;
        z-index: 100;
        transition: bottom 250ms ease-out;
        font-family: 'Inter', sans-serif;
      }
      .mtl-sticky-atc[data-visible="true"] { bottom: 0; }
      .mtl-sticky-atc__img {
        width: 44px;
        height: 44px;
        object-fit: cover;
        border-radius: 6px;
        flex-shrink: 0;
        background: #faf6f0;
      }
      .mtl-sticky-atc__info {
        flex: 1;
        min-width: 0;
      }
      .mtl-sticky-atc__title {
        font-size: 12.5px;
        font-weight: 500;
        color: #2c2c2c;
        margin: 0;
        line-height: 1.3;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .mtl-sticky-atc__price {
        font-size: 13px;
        font-weight: 600;
        color: #1a1a1a;
        margin: 2px 0 0;
      }
      .mtl-sticky-atc__btn {
        background: #3D2B1F; /* 2026-10-23 espresso CTA (was gold gradient, 2.8:1) */
        background-image: none;
        color: #fff;
        border: none;
        padding: 12px 18px;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        cursor: pointer;
        flex-shrink: 0;
        min-height: 44px;
        box-shadow: 0 2px 6px rgba(61, 43, 31, 0.22);
      }
      .mtl-sticky-atc__btn:hover { opacity: 0.92; }
      .mtl-sticky-atc__btn:focus-visible { outline: 2px solid #3D2B1F; outline-offset: 2px; }
      .mtl-sticky-atc__btn:disabled,
      .mtl-sticky-atc__btn[aria-disabled="true"] {
        opacity: 0.58;
        cursor: not-allowed;
        background: #8a8a8a;
        background-image: none;
        box-shadow: none;
      }
      .mtl-sticky-atc__btn[aria-disabled="true"] { cursor: pointer; }
      /* 2026-10-12: brief highlight on the engraving input after a sticky-bar tap */
      @keyframes mtlStickyNudge {
        0%, 35% { box-shadow: 0 0 0 3px rgba(184,146,46,0.55); }
        100% { box-shadow: 0 0 0 0 rgba(184,146,46,0); }
      }
      .mtl-sticky-nudge { animation: mtlStickyNudge 1.6s ease-out 1; }

      /* 2026-10-18: long labels (FR "Entrez votre gravure ci-dessous") squeezed title/price to 0 width; let the button wrap instead */
      .mtl-sticky-atc__btn { max-width: 58%; white-space: normal; line-height: 1.25; flex-shrink: 1; }
      .mtl-sticky-atc__price { white-space: nowrap; }
      /* Show only on mobile */
      @media (min-width: 750px) {
        .mtl-sticky-atc { display: none !important; }
      }
      @media (max-width: 749px) {
        .mtl-sticky-atc { display: flex; }
      }
    `,document.head.appendChild(style)}function findRealPdpAtc(){const selectors=["#MainContent .mtl-p button.atc-btn",".shopify-section-mtl-personalization .mtl-p button.atc-btn",'#MainContent form.mtl-p button[type="submit"]','#MainContent product-form-component button[type="submit"]',"#MainContent button[data-product-form-add-to-cart]",'#MainContent .product-form button[name="add"]','#MainContent form[action*="/cart/add"] button[name="add"]'];for(const selector of selectors){const btn=document.querySelector(selector);if(btn&&!btn.closest("product-card")&&!btn.closest('[id*="recommendations"]'))return btn}return null}function mtlSizedThumb(url,w){if(!url)return"";try{var u=new URL(url,window.location.origin),isCdn=/cdn\.shopify\.com$/.test(u.hostname)||u.pathname.indexOf("/cdn/shop/")!==-1;return isCdn?(u.searchParams.set("width",String(w||160)),u.searchParams.delete("height"),u.href):url}catch{return url}}function mtlOwnProductImage(scope){
  try{
    var og=document.querySelector('meta[property="og:image"]');
    var u=og&&(og.content||og.getAttribute("content"));
    if(u&&/\/cdn\/shop\//.test(u)) return {src:u,currentSrc:u};
  }catch(e){}
  var el=scope&&scope.querySelector(".pendant-img, .product-media img, .product__media img");
  if(el&&(el.closest("product-card")||el.closest('[id*="recommendation"]')||el.closest('[class*="recommendation"]'))) el=null;
  if(!el&&scope) el=scope.querySelector('img[src*="/cdn/shop/"]');
  return el;
}
function mtlPriceText(el){
  if(!el) return "";
  var t="";
  try{
    var c=el.cloneNode(true);
    c.querySelectorAll("small,s,del,.visually-hidden,[class*=compare]").forEach(function(n){n.remove();});
    t=(c.textContent||"").replace(/\s+/g," ").trim();
  }catch(e){ t=(el.textContent||"").replace(/\s+/g," ").trim(); }
  var m=t.match(/(?:[$€£]\s?)?\d[\d.,]*/g);
  if(m&&m.length) t=m[m.length-1];
  return t.substring(0,30);
}
function mtlIsMobile(){try{return window.matchMedia("(max-width: 749px)").matches;}catch(e){return true;}}
function injectStickyATC(){if(document.querySelector("[data-mtl-sticky-atc]"))return;if(!mtlIsMobile())return;const mtlScope=document.querySelector("#MainContent")||document,titleEl=mtlScope.querySelector("h1.product-title, h1.product__title, .product-info h1, h1")||document.querySelector("h1"),priceEl=mtlScope.querySelector(".price__regular, .product__price, [data-product-price], .price"),imgEl=mtlOwnProductImage(mtlScope),realAtc=findRealPdpAtc();if(!titleEl||!priceEl||!realAtc)return;const sticky=document.createElement("div");sticky.className="mtl-sticky-atc",sticky.setAttribute("data-mtl-sticky-atc","true"),sticky.innerHTML=`
      <img class="mtl-sticky-atc__img" loading="lazy" decoding="async" src="${mtlSizedThumb(imgEl?imgEl.currentSrc||imgEl.src:"",160)}" alt="" data-mtl-sticky-atc-img>
      <div class="mtl-sticky-atc__info">
        <p class="mtl-sticky-atc__title" data-mtl-sticky-atc-title>${titleEl.textContent.trim().substring(0,40)}${titleEl.textContent.trim().length>40?"…":""}</p>
        <p class="mtl-sticky-atc__price" data-mtl-sticky-atc-price>${mtlPriceText(priceEl)}</p>
      </div>
      <button type="button" class="mtl-sticky-atc__btn" data-mtl-sticky-atc-btn>${mtlT("sticky_add","Add to cart")}</button>
    `,document.body.appendChild(sticky);const stickyBtn=sticky.querySelector("[data-mtl-sticky-atc-btn]"),mtlNameInp=(realAtc.closest(".mtl-p")||document.createElement("i")).querySelector('[data-mtl="name-input"]'),mtlNeedsName=()=>!!(mtlNameInp&&realAtc.disabled&&!mtlNameInp.value.trim()),syncStickyButton=()=>{const label=(realAtc.textContent||"").replace(/\s+/g," ").trim(),needName=mtlNeedsName();stickyBtn.disabled=realAtc.disabled&&!needName,needName?stickyBtn.setAttribute("aria-disabled","true"):stickyBtn.removeAttribute("aria-disabled"),stickyBtn.textContent=realAtc.disabled?label||mtlT("sticky_choose","Choose finish"):mtlT("sticky_add","Add to cart"),sticky.dataset.disabled=realAtc.disabled?"true":"false"};syncStickyButton(),new MutationObserver(syncStickyButton).observe(realAtc,{attributes:!0,childList:!0,subtree:!0}),stickyBtn.addEventListener("click",e=>{if(e.preventDefault(),mtlNeedsName()){const rm=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;try{mtlNameInp.focus({preventScroll:!0})}catch(_){}mtlNameInp.scrollIntoView({behavior:rm?"auto":"smooth",block:"center"}),mtlNameInp.classList.remove("mtl-sticky-nudge"),void mtlNameInp.offsetWidth,mtlNameInp.classList.add("mtl-sticky-nudge"),setTimeout(()=>mtlNameInp.classList.remove("mtl-sticky-nudge"),1700);return}realAtc.scrollIntoView({behavior:"smooth",block:"center"}),!realAtc.disabled&&setTimeout(()=>realAtc.click(),300)}),new IntersectionObserver(entries=>{entries.forEach(entry=>{sticky.dataset.visible=entry.isIntersecting?"false":"true"})},{threshold:.1}).observe(realAtc)}function mtlFixEmptyLabel(){if(/^fr/i.test(document.documentElement.lang||""))return;/* 2026-10-12: replace generic "Name your necklace below" with the product's own step wording */document.querySelectorAll('.mtl-p [data-mtl="atc-btn"]').forEach(function(btn){if(btn.__mtlLbl)return;var form=btn.closest(".mtl-p"),inp=form&&form.querySelector('[data-mtl="name-input"]');if(!inp)return;var step=inp.closest(".step"),lab=step&&step.querySelector(".step-label"),t=lab?(lab.textContent||"").replace(/^\s*\d+\s*/,"").replace(/\(s\)/i,"s").replace(/\s+/g," ").trim():"";if(!t||t.length>24)t=mtlT("sticky_enter","Enter your engraving");btn.__mtlLbl=t;var apply=function(){var c=(btn.textContent||"").replace(/\s+/g," ").trim();if(c!==t&&(c==="Name your necklace below"||(btn.disabled&&!inp.value.trim())))btn.textContent=t};apply();new MutationObserver(apply).observe(btn,{childList:!0,characterData:!0,subtree:!0,attributes:!0,attributeFilter:["disabled"]});inp.addEventListener("input",function(){setTimeout(apply,0)})})}
function init(){injectCSS(),mtlFixEmptyLabel(),injectStickyATC(),document.querySelectorAll("[data-mtl-eta]").forEach(el=>el.remove())}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",init):init(),document.addEventListener("shopify:section:load",init),window.addEventListener("resize",function(){clearTimeout(window.__mtlStickyRz);window.__mtlStickyRz=setTimeout(init,200);}),setTimeout(init,800),setTimeout(init,2e3)})();
